import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hire-slider-skills-view',
  imports: [],
  templateUrl: './hire-slider-skills-view.component.html',
  styleUrl: './hire-slider-skills-view.component.scss',
})
export class HireSliderSkillsViewComponent {
  @Input() skills: any;
  @Input() highlightskills: any;

  highlightInfo(data: string) {

      if (data) {
        const dataForHighlight = data?.trim().toLowerCase().replace(/<.*?>/g, '').replace(/'/g, "");

        let highlightedData = data;

              if (this.highlightskills) {
                const highlightFound = this.highlightskills.find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound);
              }
              return highlightedData;
        }

        return data;
      }

}
